import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/content";
import { WhatsAppIcon, TikTokIcon } from "@/components/site/icons";
import { Heart, Phone, Mail, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="relative bg-ink text-cream">
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <span className="font-accent text-4xl text-white">IgelGemurmel</span>
            <p className="mt-3 text-cream/70 max-w-xs leading-relaxed">
              Eine private Igelstation mit Herz. Für jedes kleine Stachelherz,
              das Hilfe braucht.
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                aria-label="WhatsApp"
                className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center text-cream hover:bg-[#25D366] transition-colors"
              >
                <WhatsAppIcon className="w-5 h-5" />
              </a>
              <a
                href={CONTACT.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center text-cream hover:bg-brand-pink transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={CONTACT.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center text-cream hover:bg-brand-pink transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={CONTACT.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-tiktok"
                aria-label="TikTok"
                className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center text-cream hover:bg-black transition-colors"
              >
                <TikTokIcon className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-lg text-white">Kontakt</h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={CONTACT.phoneHref}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-3 text-cream/80 hover:text-brand-orange transition-colors"
                >
                  <Phone className="w-5 h-5" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.emailHref}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-3 text-cream/80 hover:text-brand-orange transition-colors break-all"
                >
                  <Mail className="w-5 h-5" /> {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-lg text-white">Themen</h4>
            <ul className="mt-4 space-y-2 text-cream/80">
              <li><Link to="/hilfe" className="hover:text-brand-orange transition-colors">Braucht Hilfe? & Erste Hilfe</Link></li>
              <li><Link to="/tipps" className="hover:text-brand-orange transition-colors">Garten, Futter & Auswilderung</Link></li>
              <li><Link to="/#ueber-mich" className="hover:text-brand-orange transition-colors">Über mich</Link></li>
              <li><Link to="/#spenden" className="hover:text-brand-orange transition-colors">Spenden</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-cream/60 text-sm">
            © {year} IgelGemurmel · {CONTACT.domain}
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/impressum"
              data-testid="footer-impressum"
              className="text-cream/70 text-sm hover:text-brand-orange transition-colors"
            >
              Impressum
            </Link>
            <p className="inline-flex items-center gap-2 text-cream/70 text-sm">
              Mit <Heart className="w-4 h-4 text-brand-pink" fill="#E06A88" /> für die Stachelherzen gemacht
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
